import * as React from "react";

import { Textarea, type TextareaProps } from "./textarea";

/**
 * 随内容自动增高的 Textarea(#17 口播显示不全)。
 *
 * 每次 value 变化把高度先归 auto 再设为 scrollHeight,长文完整铺开显示,不再挤在固定
 * rows 里内部滚动/截断。最小高度仍由底层 Textarea 的 min-h 决定;缩短时也会回收高度。
 * 沿用仓内既有 auto-grow 手法(PromptPanel 的 ref + scrollHeight)。
 */
export const AutoGrowTextarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ value, onChange, ...props }, forwardedRef) => {
    const innerRef = React.useRef<HTMLTextAreaElement | null>(null);

    const setRefs = React.useCallback(
      (el: HTMLTextAreaElement | null) => {
        innerRef.current = el;
        if (typeof forwardedRef === "function") forwardedRef(el);
        else if (forwardedRef) forwardedRef.current = el;
      },
      [forwardedRef]
    );

    const resize = React.useCallback(() => {
      const el = innerRef.current;
      if (!el) return;
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }, []);

    React.useLayoutEffect(() => {
      resize();
    }, [value, resize]);

    return (
      <Textarea
        ref={setRefs}
        value={value}
        onChange={(e) => {
          onChange?.(e);
          resize();
        }}
        {...props}
      />
    );
  }
);
AutoGrowTextarea.displayName = "AutoGrowTextarea";
